import Accessibility from './Accessibility'
import Language from './Language'
import Location from './Location'

const ExtraItems = () => {
  return (
    <div className="extra_items">
      <Accessibility />
      <Location />
      <Language />
    </div>
  )
}

export default ExtraItems
